var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.formComponent,_vm._g({tag:"Component",attrs:{"event":_vm.event,"clinic":_vm.clinicForEvent}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }